const version = '1.5.1';
console.log('%cpowered by MiHotel%cv' + version, 'padding: 6px 12px 6px 12px; background: #c15842; border-top-left-radius: 3px; border-bottom-left-radius: 3px; color: #fff; font-weight: bold', 'padding: 6px 12px 6px 12px; background: #fff; border-top-right-radius: 3px; border-bottom-right-radius: 3px; color: #222; font-weight: bold')
console.log('%c' + process.env.NODE_ENV, 'font-weight: bold; color: #00ff33');
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import { setupCalendar } from 'v-calendar';
import router from './router';
import store from './stores/index';
import './plugins/vcalendar.plugin';
import { mapState } from 'vuex';
import moment from 'moment';
import './plugins/translate.plugin';
import Select2 from 'v-select2-component';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import './directives'
import './filters';
import { ErrorManager } from './helpers/field-error';
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.use(VueLazyload, {
  preLoad: 1,
  error: '/static/img/default/room.png',
  loading: '/static/img/default/loader.svg',
  attempt: 3,
  throttleWait: 1000
})
Vue.use(VueScrollTo);

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.component('v-select', Select2);
setupCalendar({
  componentPrefix: 'v',
});
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App />',
  async created() {
    ErrorManager.setTranslateMethod(this.$t);
    try {
      await this.$store.dispatch('client/init');
      await this.$store.dispatch('lang/fetch');
      await this.$store.dispatch('shoppingCart/init', {lang: this.$store.state.lang.currentLang});
      this.$store.commit('SET_API_STATUS', true);
    } catch (e) {
      if (e.response === undefined) {
        this.$store.commit('SET_API_STATUS', false);
      }
    }

    moment.locale(this.$store.state.lang.currentLang);
  },
  computed: mapState({
    loading: state => state.lang.loading,
  }),
});

window.routeRGPD = function () {

  let routeData = router.resolve({name: 'privacy'});
  window.open(routeData.href, '_blank');
}

window.openModal = function (v) {
    store.commit('legalModal/SET_TAB', v);
    store.commit('legalModal/OPEN_MODAL');
}



// WEBPACK FOOTER //
// ./src/main.js